'use strict';

exports.__esModule = true;
var transformPeerRecommendations = exports.transformPeerRecommendations = function transformPeerRecommendations(peerRecommendations) {
	return (peerRecommendations || []).map(function (peerRecommendation) {
		return {
			specialty: (peerRecommendation.keywords || []).filter(function (keyword) {
				return keyword.keyword_type === 'specialty';
			}).map(function (keyword) {
				return keyword.name;
			}).join(', '),
			conditions: (peerRecommendation.keywords || []).filter(function (keyword) {
				return keyword.keyword_type === 'condition';
			}).map(function (keyword) {
				return keyword.name;
			}).join(', '),
			procedures: (peerRecommendation.keywords || []).filter(function (keyword) {
				return keyword.keyword_type === 'procedure';
			}).map(function (keyword) {
				return keyword.name;
			}).join(', ='),
			id: peerRecommendation.id,
			recommendationText: peerRecommendation.recommendation,
			connection: peerRecommendation.connection,
			authorName: peerRecommendation.recommender_title + ' ' + peerRecommendation.recommender_firstname + ' ' + peerRecommendation.recommender_lastname,
			recomendeeFirstname: peerRecommendation.recommendee_firstname,
			recommendeeId: peerRecommendation.recommendee_id,
			recommendeeLastName: peerRecommendation.recommendeeLastname,
			recommendeeProfileImage: peerRecommendation.recommendee_profile_image,
			recommendeeTitle: peerRecommendation.recommendee_title,
			recommenderFirstname: peerRecommendation.recommender_firstname,
			recommenderId: peerRecommendation.recommender_id,
			recommenderLastname: peerRecommendation.recommender_lastname,
			authorProfileImage: peerRecommendation.recommender_profile_image + '_lg.jpg',
			recommenderTitle: peerRecommendation.recommender_title,
			status: peerRecommendation.status,
			recommendationDate: peerRecommendation.timestamp_created,
			timestampModified: peerRecommendation.timestamp_modified,
			recommendeeName: (((peerRecommendation.recommendee_title || '') + ' ' + (peerRecommendation.recommendee_firstname || '')).trim() + ' ' + (peerRecommendation.recommendee_lastname || '')).trim(),
			specialistUri: peerRecommendation.recommendee_uri_id
		};
	});
};